import { gql } from 'graphql-request';

export default gql`mutation submitVacancyForm($VacancyFormInput: VacancyFormInput!) {
    submitVacancyForm(
        input: $VacancyFormInput
    ) {
        success_message
    }
}`;